import {
  INACTIVE_BILLING_STATUS,
  type BillingSubscriptionStatus,
} from './subscription-status'

export interface BillingSubscriptionStatusResponse {
  status: BillingSubscriptionStatus
  trial_days_remaining: number
}

export interface BillingCustomerSessionResponse {
  client_secret: string
  pricing_table_id: string
}

export interface BillingCustomerPortalSessionResponse {
  url: string
}

export const INACTIVE_BILLING_SUBSCRIPTION_RESPONSE: BillingSubscriptionStatusResponse =
  {
    status: INACTIVE_BILLING_STATUS,
    trial_days_remaining: 0,
  }

export interface BillingUserUsageResponse {
  billing_period_start: string
  billing_period_end: string
  characters_used: number
  characters_limit: number | null
  documents_used: number
  documents_limit: number | null
  days_until_characters_limit: number | null
  days_until_documents_limit: number | null
  glossary_count_limit: number | null
  glossary_entries_limit: number | null
  memory_count_limit: number | null
  memory_entries_limit: number | null
}
